const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.453,
    height: 20.244,
    viewBox: "0 0 19.453 20.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5056",
    d: "M11.219 322.55a4.152 4.152 0 1 0 5.872 5.872l.419-.42-5.872-5.872z",
    transform: "translate(-10.003 -309.392)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5057",
    d: "M222.256 122.983a4.152 4.152 0 1 0-5.872-5.872l-.419.419 5.872 5.872z",
    transform: "translate(-207.821 -111.311)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5058",
    d: "m77.407 178.51-4.832 4.84 5.872 5.872 4.832-4.84z",
    transform: "translate(-70.101 -171.451)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5059",
    d: "M319.119 4.734a1.779 1.779 0 0 0-2.363-2.39l-.911-.911.419-.419a.593.593 0 1 0-.839-.839l-1.678 1.678a.593.593 0 0 0 .839.839l.419-.419.839.839-.806.807a5.368 5.368 0 0 1 2.514 2.519l.786-.786a5.346 5.346 0 0 1-.4 7.107l-2.169 2.169a1.778 1.778 0 1 0 .84.838l2.169-2.169a6.533 6.533 0 0 0 .338-8.862z",
    transform: "translate(-301.236 -.001)",
    style: {
      fill: "#d9d9d9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.3a7a50b60ab2b88151d34688e2aafed3.svg";
export { ForwardRef as ReactComponent };